export const GLOBAL_ATOM_KEYS = {
  STORE_ROOT_PROPS: 'props',
  IS_OPEN_LINK: 'isOpenLink',
  IS_OPEN_MODAL: 'is_open_modal',
  SNACKBAR_MESSAGE: 'snackbar_list',
  STORE_MODULE: 'store_module',
} as const
